import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function LegalFooter() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        pt: 2,
        pb: 2,
        px: 2,
        textAlign: 'center',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)'
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Want to add songs? Think a song should be different? Missing openings?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        For suggestions or any other inquiries, contact us at{' '}
        <Link href="mailto:mediumfungames@gmail.com">mediumfungames@gmail.com</Link>.
      </Typography>
      <Typography variant="body2" color="text.secondary" component="nav" aria-label="Footer">
        <Link component={RouterLink} to="/">Home</Link>
        {' · '}
        <Link component={RouterLink} to="/how-to-play">How to play</Link>
        {' · '}
        <Link component={RouterLink} to="/about">About</Link>
        {' · '}
        <Link component={RouterLink} to="/privacy">Privacy & Cookies</Link>
        {' · '}
        <Link component={RouterLink} to="/terms">Terms</Link>
        {' · '}
        <Link component={RouterLink} to="/contact">Contact</Link>
      </Typography>
    </Box>
  );
}
